/*global myModal, tmLogger, inputDirectionChange */

var authentication = {
    popUpAuthWindow: null,
    loginModalProps: {
        modalWindowClass: 'bg-black-04 default new',
        closeOutside: true,
        onlyClose: true,
        noHeader: true
    },
    init: function() {
        authentication.actions();
        authentication.showStep1();
        authentication.signUp($('#main-wrapper-body'));
        authentication.resendMagicLink();
    },
    actions: function() {
        $('body').on('click', '.trigger-login-modal', function(e) {
            e.preventDefault();

            tmLogger.setEventLabel($(this).data('label'));
            tmLogger.sendEvent('userAccountLogin');

            myModal.close();
            authentication.showStep1();
            myModal.staticModal('loginModal', authentication.loginModalProps);
            authentication.signUp($('.modal'));
        }).on('click', '.trigger-login-modal-partner', function(e) {
            e.preventDefault();

            tmLogger.setEventLabel('Partner Deals');
            tmLogger.sendEvent('userAccountLogin');

            myModal.close();
            authentication.showStep1();
            myModal.staticModal('loginForPartnerDealsModal', authentication.loginModalProps);
            authentication.signUp($('.modal'));
            setTimeout(function() {
                $('.modal').find('form').each(function() {
                    $(this).append('<input type="hidden" name="cug" value="1">');
                });
            }, 400);
        }).on('click', '#continueWithEmail', function() {
            authentication.showStep2();
        }).on('click', '#triggerContinueWithEmail', function() {
            $('.trigger-login-modal').trigger('click');
            setTimeout(function() {
                authentication.showStep2();
            }, 100);
        }).on('click', '.prev-step', function() {
            const step = $(this).data('step');

            if (step === 'step-2') {
                authentication.showStep2();
            } else {
                authentication.showStep1();
            }
        });
    },
    showStep1: function() {
        $('.authentication-wrapper').hide().filter('.step-1').show();
    },
    showStep2: function() {
        $('.sign-up-with-email').removeClass('loading');
        $('.authentication-wrapper').hide().filter('.step-2').show();
        inputDirectionChange.onChangeAction('#sign-up-email');
    },
    showStep3: function() {
        $('.authentication-wrapper').hide().filter('.step-3').show();
    },
    signUp: function(parentHandler) {
        parentHandler.on('click', '.sign-up-with-email', function(e) {
            e.preventDefault();
            const btn = $(this);

            if (btn.hasClass('loading')) {
                return false;
            }

            btn.addClass('loading');

            $('#signUpWithEmailForm').submit();
        });

        const signUpWithEmailValidator = $(document).find('#signUpWithEmailForm').validate({
            errorClass: 'error',
            focusInvalid: false,
            errorElement: 'div',
            rules: {
                sign_up_email: {
                    validate_email: true
                }
            },
            errorPlacement: function(error, el) {
                $(el).next().html(error);
            },
            highlight: function(el, ec) {
                $(el).addClass(ec);
            },
            unhighlight: function(el, ec) {
                $(el).removeClass(ec);
            },
            invalidHandler: function() {
                setTimeout(function() {
                    $('.sign-up-btn').removeClass('loading');
                }, 10);
            },
            submitHandler: function(form) {
                $.postJSON(_d.url.authentication.magicLink, $(form).serialize(), function(response) {
                    if (!response.error) {
                        $('#signUpSuccessMessage').html(response.message);
                        authentication.showStep3();
                    } else {
                        signUpWithEmailValidator.showErrors({
                            'sign_up_email': response.message
                        });
                        $('.sign-up-btn').removeClass('loading').blur();
                    }
                });
            }
        });
    },
    resendMagicLink: function() {
        $('body').on('click', '#expired-magic-link-btn', function() {
            const [, magicLinkToken = ''] = location
                .pathname
                .match(/\/redirect\/(.+)/) || [];
            const btn = $('#expired-magic-link-btn');

            if (btn.hasClass('loading')) {
                return;
            }

            btn.addClass('loading');

            $.get(`/login/magic-link/resend/${magicLinkToken}`, function(response) {
                if (!response.error) {
                    myModal.close();
                    $('#signUpSuccessMessage').html(response.message);
                    authentication.showStep3();
                    myModal.staticModal('loginModal', authentication.loginModalProps);
                } else {
                    window.location.href = _d.url.authentication.errorAuth;
                }

                btn.remove('loading').blur();
            });
        });
    }
};
